import { render, staticRenderFns } from "./WizardFourthStep.vue?vue&type=template&id=2dcb5848&"
import script from "./WizardFourthStep.vue?vue&type=script&lang=js&"
export * from "./WizardFourthStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports